import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getFirestore, collection, query, where, orderBy, limit, getDocs } from 'firebase/firestore';
import PropTypes from 'prop-types';

function DashboardCard10({ stockSymbol }) {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const db = getFirestore();

  useEffect(() => {
    const fetchPosts = async () => {
      if (!stockSymbol) {
        setLoading(false);
        return;
      }
      
      try {
        const postsRef = collection(db, 'posts');
        // Ensure stockSymbol is uppercase for consistency
        const normalizedSymbol = stockSymbol.toUpperCase();
        
        // Query with index
        const q = query(
          postsRef,
          where('stockSymbol', '==', normalizedSymbol),
          orderBy('timestamp', 'desc'),
          limit(4)
        );
        
        const snapshot = await getDocs(q);
        const fetchedPosts = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        
        setPosts(fetchedPosts);
        setError(null);
      } catch (error) {
        console.error('Error fetching posts:', error);  
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPosts();
  }, [stockSymbol, db]);


  const handleForumClick = () => {
    navigate('/community/forum');
  };

  const handlePostClick = (postId) => {
    navigate(`/community/forum/post/${postId}`); // Fixed typo: navugate -> navigate
  };

  if (loading) {
    return (
      <div className="flex flex-col col-span-full sm:col-span-6 bg-white dark:bg-gray-800 shadow-lg rounded-xl p-4">
        <div className="flex items-center justify-center h-full">Loading...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex flex-col col-span-full sm:col-span-6 bg-white dark:bg-gray-800 shadow-lg rounded-xl p-4">
        <div className="flex items-center justify-center h-full text-red-500">
          Error loading posts. Please try again later.
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col col-span-full sm:col-span-6 bg-white dark:bg-gray-800 shadow-lg rounded-xl p-4">
      <header className="px-5 py-4 border-b border-gray-100 dark:border-gray-700/60">
        <h2 className="font-semibold text-gray-800 dark:text-gray-100">
          Forum aktivitet for {stockSymbol}
        </h2>
      </header>
      <div className="p-3">
        <div>
          <header 
            className="text-xs uppercase text-gray-400 dark:text-gray-500 bg-gray-50 dark:bg-gray-700 dark:bg-opacity-50 rounded-sm font-semibold p-2 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-600"
            onClick={handleForumClick}
          >
            Forum
          </header>
          {posts.length > 0 ? (
            <ul className="my-1">
              {posts.map((post) => (
                <li key={post.id} className="flex px-2">
                  <div className="w-9 h-9 rounded-full shrink-0 bg-violet-500 my-2 mr-3">
                    <svg className="w-9 h-9 fill-current text-white" viewBox="0 0 36 36">
                      <path d="M18 10c-4.4 0-8 3.1-8 7s3.6 7 8 7h.6l5.4 2v-4.4c1.2-1.2 2-2.8 2-4.6 0-3.9-3.6-7-8-7zm4 10.8v2.3L18.9 22H18c-3.3 0-6-2.2-6-5s2.7-5 6-5 6 2.2 6 5c0 2.2-2 3.8-2 3.8z" />
                    </svg>
                  </div>
                  <div className="grow flex items-center border-b border-gray-100 dark:border-gray-700/60 text-sm py-2">
                    <div className="grow flex justify-between">
                      <div className="self-center">
                        <a className="font-medium text-gray-800 hover:text-gray-900 dark:text-gray-100 dark:hover:text-white" href="#0">
                          {post.author}
                        </a> 
                        {' Indlæg: '} 
                        {post.title}
                      </div>
                      <div className="shrink-0 self-end ml-2">
                      <button 
                onClick={() => handlePostClick(post.id)}
                className="font-medium text-violet-500 hover:text-violet-600 dark:hover:text-violet-400 cursor-pointer"
              >
                Læs<span className="hidden sm:inline"> -&gt;</span>
              </button>
                      </div>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-center text-gray-500 dark:text-gray-400 py-4">
              Ingen indlæg fundet for denne  aktie
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

DashboardCard10.propTypes = {
  stockSymbol: PropTypes.string.isRequired
};

export default DashboardCard10;